import { render, staticRenderFns } from "./NoteCategoriesNew.vue?vue&type=template&id=2814d34a&scoped=true&"
import script from "./NoteCategoriesNew.vue?vue&type=script&lang=js&"
export * from "./NoteCategoriesNew.vue?vue&type=script&lang=js&"
import style0 from "./NoteCategoriesNew.vue?vue&type=style&index=0&id=2814d34a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2814d34a",
  null
  
)

export default component.exports